import type { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';

/**
 * MultiSelect component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/multiselect/index.ts
 *
 * Component documentation:
 * https://primeng.org/multiselect
 */
export const multiselectComponentTokens: Partial<MultiSelectDesignTokens> = {
  optionGroup: {
    color: '{multiselect.option.color}',
  },
};
